import React from 'react'
import "./seeSomeOfThePerformance.scss"

//Imagens:
import ImgSeeSomeOfThePerformance from "../../../../assets/example/example.png"
import { useTranslation } from 'react-i18next'

function SeeSomeOfThePerformance() {
  const { t } =  useTranslation()

  return (
    <div className='container-see-some-of-the-performance'>
      <div className="img-see-some-of-the-performance">
        <img src={ImgSeeSomeOfThePerformance} alt="" />
      </div>
      <div className="texts-see-some-of-the-performance">
        <h1>{t("examples.title")}</h1>
        <p>{t("examples.section_text")}</p>
      </div>
    </div>
  )
}

export default SeeSomeOfThePerformance